import { Tabs } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"
import { useLocation, useNavigate } from "react-router-dom"

import { useTabsOpenInNewTab } from "../../../../hooks/use-tabs-open-in-new-tab.tsx"
import { useAutomationSections } from "../../hooks/use-automation-sections.ts"

// Communication, Status and Required Information each keep their own page and
// gate; this strip only switches between the ones the user may open.
export function AutomationSubTabs() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const pathname = useLocation()?.pathname
  const sections = useAutomationSections()

  // Communication's route is the prefix of the other two, so the longest
  // match wins and an automation's own id still reads as Communication.
  const activeKey = sections
    .filter(
      ({ route }) => pathname === route || pathname?.startsWith(`${route}/`)
    )
    .reduce(
      (longest, { route }) => (route.length > longest.length ? route : longest),
      ""
    )

  const newTab = useTabsOpenInNewTab((key) =>
    sections.some(({ route }) => route === key) ? key : undefined
  )

  return (
    <div className="mb-3" {...newTab.handlers}>
      {newTab.contextMenu}
      <div className="text-xs uppercase tracking-wide text-gray-400 mb-1">
        {t("settingsAutomation.tab")}
      </div>
      <Tabs
        activeKey={activeKey || sections[0]?.route}
        items={sections.map(({ route, labelKey }) => ({
          key: route,
          label: t(labelKey)
        }))}
        onChange={navigate}
        className="[&_.ant-tabs-nav]:mb-0 [&_.ant-tabs-tab]:py-1"
      />
    </div>
  )
}
